import React from 'react';
import PropTypes from 'prop-types';

const SORT_OPTIONS = [
  { value: 'name', label: 'Name (A-Z)' },
  { value: 'name-desc', label: 'Name (Z-A)' },
  { value: 'popularity', label: 'Busiest first' },
  { value: 'popularity-asc', label: 'Quietest first' },
];

const FavoritesFilter = ({ searchQuery, onSearchChange, sortBy, onSortChange, count }) => {
  const hasActiveFilters = searchQuery || sortBy !== 'name';

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-400 dark:text-gray-500 font-light">
          {count} {count === 1 ? 'place' : 'places'} saved
        </span>
        {hasActiveFilters && (
          <button
            onClick={() => {
              onSearchChange('');
              onSortChange('name');
            }}
            className="text-xs text-honey-600 hover:text-honey-700 font-medium transition-colors"
          >
            Clear filters
          </button>
        )}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <div className="relative group">
            <input
              type="text"
              placeholder="Search favorites..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full p-3 pl-10 min-h-[44px] glass rounded-xl text-sm text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-honey-400/50 transition-all duration-300"
            />
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-honey-500 transition-transform duration-300 group-focus-within:scale-110"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
        <div className="sm:w-44">
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="w-full p-3 min-h-[44px] glass rounded-xl text-sm text-gray-700 dark:text-gray-200
              focus:outline-none focus:ring-2 focus:ring-honey-400/50 transition-all duration-300
              appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%239CA3AF%22%20stroke-width%3D%222%22%3E%3Cpath%20d%3D%22M6%209l6%206%206-6%22%2F%3E%3C%2Fsvg%3E')] bg-no-repeat bg-[right_0.75rem_center]"
          >
            {SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

FavoritesFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  count: PropTypes.number,
};

export default FavoritesFilter;
